import { useCallback } from 'react';

// Definimos una interfaz para el retorno del hook (opcional, pero buena práctica)
interface UseCookiesReturn {
  setCookie: (name: string, value: string, days?: number) => void;
  getCookie: (name: string) => string | null;
  eraseCookie: (name: string) => void;
}

function useCookies(): UseCookiesReturn {

  const setCookie = useCallback((name: string, value: string, days: number = 7): void => {
    const expires = new Date();
    const daysNum = days;

    expires.setTime(expires.getTime() + daysNum * 24 * 60 * 60 * 1000);

    // Agregamos Secure si estás en HTTPS para mayor seguridad
    const secure = window.location.protocol === 'https:' ? 'Secure;' : '';

    document.cookie = `${name}=${value}; expires=${expires.toUTCString()}; path=/; SameSite=Lax; ${secure}`;
  }, []);

  const getCookie = useCallback((name: string): string | null => {
    const nameEQ = `${name}=`;
    const ca = document.cookie.split(';');

    for (let i = 0; i < ca.length; i++) {
      let c = ca[i].trim();
      if (c.indexOf(nameEQ) === 0) {
        return c.substring(nameEQ.length, c.length);
      }
    }
    return null;
  }, []);

  const eraseCookie = useCallback((name: string): void => {
    setCookie(name, '', -1);
  }, [setCookie]);

  return { setCookie, getCookie, eraseCookie };
}

export default useCookies;